// import React from 'react'
// import { Button, Grid2, Typography } from '@mui/material'
// import { Constants, Main_URL } from '../../shared/constants'
// import useResponsive from '../../shared/utils/Responsive'
// import { useLocation, useNavigate } from 'react-router-dom'
// import { CustomButtonContained } from '../../shared/utils/CustomButton'

// const KnowMoreSection = ({content}) => {
//     console.log(content,"content")
//     const isSmallScreen = useResponsive("md")
//     const navigate = useNavigate();
//     const location = useLocation();
//     return (
//         // <BackgroundImageComponent imageUrl={Constants.customImages.TwoBrothers} lineargradient={"linear-gradient(279.52deg, rgba(0, 0, 0, 0) 4.45%, #000000 98.98%)"} >
//         //     <Typography variant='h2' color='primary.main'>On Boarding <Typography variant='h2' component={"span"} color='#FF8F8F'>Made Easy!</Typography></Typography>
//         //     <Typography variant='body1' color='primary.main' mb={3} mt={1.5} width={{ xs: "auto", lg: "55%" }}>{isSmallScreen ? "Experience a hassle-free onboarding process designed for your comfort. From key handovers to utility setups." : " Experience a hassle-free onboarding process designed for your comfort. From key handovers to utility setups, we take care of everything so you can settle into your new home with ease."}</Typography>
//         //     {
//         //         location.pathname !== "/Apartmentonboarding" && (
//         //             <>

//         //                 {!isSmallScreen &&
//         //                     <Grid2 container>
//         //                         <Grid2 children size={3.5}>
//         //                             <Button variant='contained' fullWidth onClick={() => { navigate("/Apartmentonboarding") }}>Onboard Now</Button>
//         //                         </Grid2>

//         //                     </Grid2>
//         //                 }
//         //                 {isSmallScreen && <Button variant='contained' fullWidth onClick={() => { navigate("/Apartmentonboarding") }}>Onboard Now</Button>}
//         //             </>
//         //         )
//         //     }

//         // </BackgroundImageComponent>

//         <Grid2 container

//             sx={{

//                 position: "relative",
//                 backgroundImage: `url(${Constants.customImages.KnowMoreSec})`,
//                 backgroundSize: { xs: "cover", md: "100% auto" },
//                 backgroundPosition: "top",
//                 backgroundRepeat: "no-repeat",
//                 borderRadius: "40px",
//                 overflow: "hidden",
//                 height: { xs: "400px", sm: "300px", md: "370px" }, // ✅ fixed typo
//                 p: { xs: "10px", sm: "20px" }

//             }}


//         >
//             <Grid2 children size={{ xs: 12, sm: 5.5 }}>
//                 <Typography variant='h2' color='primary.main' sx={style.heading}>On Boarding <Typography variant='h2' component={"span"} color='#FF8F8F' sx={style.heading}>Made Easy!</Typography></Typography>

//                 <Typography variant='body1' color='primary.main' mb={3} mt={1.5} sx={style.text} >
//                     Experience a hassle-free onboarding process designed for your comfort. Be a part of new age education revolution, Be a part of MySkill Club
//                 </Typography>
//                 {
//                     isSmallScreen ? <CustomButtonContained buttonText="Onboard now" onClick={() => { navigate("/Apartmentonboarding") }} /> : <Button variant='contained' onClick={() => { navigate("/Apartmentonboarding") }}>Onboard now</Button>
//                 }


//             </Grid2>
//             <Grid2 children size={{ xs: 2, sm: 0 }}></Grid2>
//             <Grid2 children size={{ xs: 10, sm: 6.5 }} sx={{
//                 display: "flex",
//                 flexDirection: "column",
//                 justifyContent: "end",
//                 alignItems: "end"
//             }}>

//                 <Typography variant='h2' color='primary.main' textAlign={"end"} sx={style.heading}>Become a Trainer : Empowering</Typography>
//                 <Typography variant='h2' color='#FF8F8F' textAlign={"end"} sx={style.heading}> the Leaders of Learning </Typography>

//                 <Typography variant='body1' color='primary.main' mb={3} mt={1.5} textAlign={"end"} sx={style.text}>Get ready to inspire, lead, and elevate. Your journey as a trainer starts here—with the tools, support, and mindset to make an impact.</Typography>

//                 {
//                     isSmallScreen ? <CustomButtonContained buttonText="Claim your place" onClick={() => window.open(`${Main_URL}pro/register`, "_blank")} /> : <Button variant='contained' onClick={() => window.open(`pro/register`, "_blank")}>Claim your place</Button>
//                 }

//             </Grid2>

//         </Grid2>
//     )
// }


// const style = {
//     heading: {
//         fontSize: { xs: "16px", md: "25px" },
//         lineHeight: { xs: "18px", md: "30px" },
//     },
//     text: {
//         fontSize: { xs: "10px", md: "14px" },
//         lineHeight: { xs: "14px", md: "20px" },
//     }
// }


// export default KnowMoreSection



import React from 'react';
import { Button, Grid2, Typography } from '@mui/material';
import { Constants, Main_URL } from '../../shared/constants';
import useResponsive from '../../shared/utils/Responsive';
import { useNavigate } from 'react-router-dom';
import { CustomButtonContained } from '../../shared/utils/CustomButton';

const KnowMoreSection = ({ content }) => {
  const isSmallScreen = useResponsive("md");
  const navigate = useNavigate();

  if (!content?.data?.subcategories?.length) return null;
  return (
    <Grid2
      container
      sx={{
        position: "relative",
        backgroundImage: `url(${Constants.customImages.KnowMoreSec})`,
        backgroundSize: { xs: "cover", md: "100% auto" },
        backgroundPosition: "top",
        backgroundRepeat: "no-repeat",
        borderRadius: "40px",
        overflow: "hidden",
        height: { xs: "400px", sm: "300px", md: "370px" },
        p: { xs: "10px", sm: "20px" }
      }}
    >
      {content?.data?.subcategories?.map((item, index) => (
        <Grid2
          key={index}
          children
          size={{ xs: 12, sm: 6 }}
          sx={{
            display: "flex",
            flexDirection: "column",
            justifyContent: index % 2 === 0 ? "start" : "end",
            alignItems: index % 2 === 0 ? "start" : "end",
            textAlign: index % 2 === 0 ? "left" : "right",
            mb: 2
          }}
        >
          <Typography variant='h2' color='primary.main' sx={style.heading}  dangerouslySetInnerHTML={{ __html: item?.heading }}/>
            {/* {item?.heading?.split(":")[0]}{" "}
            <Typography variant='h2' component={"span"} color='#FF8F8F' sx={style.heading}>
              {item?.heading?.split(":")[1] || ""}
            </Typography>
          </Typography> */}

          <Typography
            variant='body1'
            color='primary.main'
            mb={3}
            mt={1.5}
            sx={style.text}
            dangerouslySetInnerHTML={{ __html: item.description }}
          />

          {isSmallScreen ? (
            <CustomButtonContained
              buttonText={item.buttonText}
              onClick={() => {
                if (item?.buttonUrl?.startsWith("http") || item?.buttonUrl?.startsWith(Main_URL)) {
                  window.open(item.buttonUrl, "_blank");
                } else {
                  navigate(item.buttonUrl);
                }
              }}
            />
          ) : (
            <Button
              variant='contained'
              onClick={() => {
                if (item?.buttonUrl?.startsWith("http") || item?.buttonUrl?.startsWith(Main_URL)) {
                  window.open(item.buttonUrl, "_blank");
                } else {
                  navigate(item.buttonUrl);
                }
              }}
            >
              {item.buttonText}
            </Button>
          )}
        </Grid2>
      ))}
    </Grid2>
  );
};

const style = {
  heading: {
    fontSize: { xs: "16px", md: "25px" },
    lineHeight: { xs: "18px", md: "30px" },
  },
  text: {
    fontSize: { xs: "10px", md: "14px" },
    lineHeight: { xs: "14px", md: "20px" },
  },
};

export default KnowMoreSection;
